<template>
  <v-container fluid>
    <base-material-card color="primary" icon="mdi-calculator-variant-outline" inline class="ml-0 px-5 py-4">
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">Racionalização do COM</div>
      </template>

      <v-btn
        id="btn-nova-racionalizacao-com"
        color="success"
        dark
        elevation="1"
        class="mt-5"
        style="float: left"
        relative
        text
        medium
        @click="$router.push('edit')"
      >
        <v-icon left size="30px">mdi-plus-circle</v-icon>
        Nova Racionalização
      </v-btn>

      <v-text-field
        id="racionalizacao-com-historico-search"
        v-model="search"
        append-icon="mdi-magnify"
        class="break-search ml-auto mt-4"
        label="Procurar"
        hide-details
        single-line
        style="max-width: 250px"
      />

      <general-progress-bars class="mt-11" :items="downloadProgressData" prefix-text="Baixando Racionalização do COM" />

      <v-divider class="mt-10" />

      <v-data-table
        :headers="headers"
        :items="items"
        :search.sync="search"
        :header-props="{ sortByText: 'Ordenar Por' }"
        :footer-props="{ itemsPerPageText: 'Itens por Página' }"
        no-data-text="Nenhuma execução disponível"
        no-results-text="Nenhum registro correspondente encontrado"
        :loading="loading"
        mobile-breakpoint="800"
      >
        <template v-slot:[`item.nome`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div
                class="text-truncate-column"
                :class="canAcompanharLogs(item) ? 'clickable-item' : ''"
                v-bind="attrs"
                v-on="on"
                @click="openDialogAcompanhamentoLogs(item)"
              >
                {{ item.nome }}
              </div>
            </template>
            <span>{{ item.nome }}</span>
          </v-tooltip>
        </template>

        <template v-slot:[`item.usuario`]="{ item }">
          {{ item.usuario ? item.usuario.nome : '-' }}
        </template>

        <template v-slot:[`item.data_processamento`]="{ item }">
          {{ item.data_processamento | parseToDateTimeBR }}
        </template>

        <template v-slot:[`item.status`]="{ item }">
          <general-status :status="item.status" />
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            id="action-download-racionalizacao-com"
            :class="item.status !== 'SUCESSO' ? 'cursor-block' : ''"
            min-width="0"
            class="px-1"
            fab
            icon
            x-small
            :loading="downloadProgressData[item.id] !== undefined"
            :disabled="item.status !== 'SUCESSO'"
            @click="downloadItem(item)"
          >
            <v-icon small>mdi-download</v-icon>
          </v-btn>

          <v-btn
            id="action-edit-racionalizacao-com"
            :class="!canEditItem(item) ? 'cursor-block' : ''"
            :disabled="!canEditItem(item)"
            min-width="0"
            class="ml-n1 px-1"
            fab
            icon
            x-small
            @click="$router.push(`edit/${item.id}`)"
          >
            <v-icon small>mdi-pencil</v-icon>
          </v-btn>

          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                id="action-more-racionalizacao-com"
                color="white"
                class="ml-1"
                height="22px"
                width="22px"
                fab
                x-small
                elevation="1"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon small>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item v-if="canRunItem(item)" @click="executarItem(item.id)">
                <v-list-item-icon class="mx-0 my-0 py-4">
                  <v-icon small>mdi-play</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Executar</v-list-item-title>
              </v-list-item>
              <v-list-item @click="openDialogDetalhes(item)">
                <v-list-item-icon class="mx-0 my-0 py-4">
                  <v-icon small>mdi-information-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Detalhes</v-list-item-title>
              </v-list-item>
              <v-list-item v-if="canDeleteItem(item)" @click="openDialogDelete(item.id, item.nome)">
                <v-list-item-icon class="mx-0 my-0 py-4">
                  <v-icon small>mdi-trash-can-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Excluir</v-list-item-title>
              </v-list-item>
              <v-list-item @click="duplicarItem(item.id)">
                <v-list-item-icon class="mx-0 my-0 py-4">
                  <v-icon small>mdi-content-copy</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Duplicar</v-list-item-title>
              </v-list-item>
              <v-list-item v-if="canAcompanharLogs(item)" @click="openDialogAcompanhamentoLogs(item)">
                <v-list-item-icon class="mx-0 my-0 py-4">
                  <v-icon small>mdi-text-box-search-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Acompanhar logs</v-list-item-title>
              </v-list-item>
              <v-list-item @click="downloadLogsTecnicos(item.id)">
                <v-list-item-icon class="mx-0 my-0 py-4">
                  <v-icon small>mdi-file-download-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Baixar logs</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>

        <template v-slot:[`footer`]>
          <v-switch
            v-if="$store.getters.userIsAdmin"
            class="pa-0 pl-2 swithInterna"
            style="position: absolute"
            color="primary"
            label="Exibir Expirados"
            dense
            @change="$emit('switchProcessamentosExpirados', $event)"
          />
        </template>

        <template v-slot:[`footer.page-text`]>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="primary" v-bind="attrs" v-on="on" @click="$emit('rechargeTable')">mdi-refresh</v-icon>
            </template>
            <span>Clique aqui para recarregar os registros</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </base-material-card>

    <dialog-delete
      :show-dialog="dialogDelete"
      @changeValue="dialogDelete = $event"
      @deleteTriggered="deletarItem(dialogDeleteData.id)"
    >
      <template slot="title">Excluir Racionalização do COM #{{ dialogDeleteData.id }}</template>
      <template slot="body">
        Tem certeza que deseja excluir
        <strong>{{ dialogDeleteData.titulo }}</strong>
        ?
      </template>
    </dialog-delete>

    <general-dialog-detalhes
      ref="dialogDetalhes"
      title="Detalhes da Racionalização do COM"
      :show-dialog="dialogDetalhes"
      @changeValue="dialogDetalhes = $event"
    >
      <template slot="body">
        <v-data-table
          dense
          :headers="dialogDetalhesHeader"
          :items="dialogDetalhesData"
          hide-default-footer
          disable-pagination
          class="elevation-1 style-table-dialog-detalhes"
        >
          <template v-slot:item="row">
            <tr>
              <td class="button">{{ row.item.parametro }}</td>
              <td v-if="row.item.parametro === 'Status'" class="button">
                <general-status :status="row.item.valor" />
              </td>
              <td v-else class="button">{{ row.item.valor }}</td>
            </tr>
          </template>
        </v-data-table>
      </template>
    </general-dialog-detalhes>

    <dialog-acompanhamento-logs
      :show-dialog="dialogAcompanhamentoLogs"
      :messages="dialogAcompanhamentoLogsMessages"
      :loading="dialogAcompanhamentoLogsLoading"
      @changeValue="onDialogAcompanhamentoLogsChange"
    >
      <template slot="title">Logs da Racionalização do COM #{{ dialogAcompanhamentoLogsId }}</template>
    </dialog-acompanhamento-logs>
  </v-container>
</template>

<script>
  import RacionalizacaoComService from '@/services/RacionalizacaoComService';
  import powerupsActionsMixins from '@/mixins/powerupsActionsMixins';
  import dateFormatterMixins from '@/mixins/dateFormatterMixins';

  export default {
    components: {
      GeneralStatus: () => import('@/components/general/GeneralStatus.vue'),
      GeneralProgressBars: () => import('@/components/general/GeneralProgressBars.vue'),
      DialogDelete: () => import('@/components/general/DialogDelete'),
      GeneralDialogDetalhes: () => import('@/components/general/GeneralDialogDetalhes'),
      DialogAcompanhamentoLogs: () => import('@/components/racionalizacaoCom/DialogAcompanhamentoLogs.vue')
    },
    mixins: [powerupsActionsMixins, dateFormatterMixins],
    props: {
      items: {
        type: Array,
        default: () => []
      },
      loading: {
        type: Boolean,
        required: true
      }
    },
    emits: ['switchProcessamentosExpirados', 'rechargeTable'],
    data: () => ({
      powerupService: RacionalizacaoComService,
      powerupEntityName: 'Racionalizacao do COM',
      search: '',
      headers: [
        { text: 'ID', value: 'id' },
        { text: 'Nome', value: 'nome' },
        { text: 'Usuário', value: 'usuario' },
        { text: 'Processado em', value: 'data_processamento' },
        { text: 'Status', value: 'status' },
        { text: 'Ações', value: 'actions', sortable: false, class: 'pl-4' }
      ],
      dialogAcompanhamentoLogs: false,
      dialogAcompanhamentoLogsId: null,
      dialogAcompanhamentoLogsMessages: [],
      dialogAcompanhamentoLogsLoading: false,
      dialogAcompanhamentoLogsInterval: null
    }),
    beforeDestroy() {
      this.pararPollAcompanhamentoLogs();
    },
    methods: {
      canAcompanharLogs(item) {
        return ['AGUARDANDO', 'EXECUTANDO'].includes(item.status);
      },
      openDialogAcompanhamentoLogs(item) {
        if (!this.canAcompanharLogs(item)) {
          return;
        }

        this.dialogAcompanhamentoLogsId = item.id;
        this.dialogAcompanhamentoLogsMessages = [];
        this.dialogAcompanhamentoLogs = true;
        this.carregarAcompanhamentoLogs();
        this.iniciarPollAcompanhamentoLogs();
      },
      onDialogAcompanhamentoLogsChange(aberto) {
        this.dialogAcompanhamentoLogs = aberto;
        if (!aberto) {
          this.pararPollAcompanhamentoLogs();
          this.dialogAcompanhamentoLogsId = null;
          this.dialogAcompanhamentoLogsMessages = [];
        }
      },
      iniciarPollAcompanhamentoLogs() {
        this.pararPollAcompanhamentoLogs();
        this.dialogAcompanhamentoLogsInterval = setInterval(() => {
          this.carregarAcompanhamentoLogs();
        }, 30000);
      },
      pararPollAcompanhamentoLogs() {
        if (this.dialogAcompanhamentoLogsInterval) {
          clearInterval(this.dialogAcompanhamentoLogsInterval);
          this.dialogAcompanhamentoLogsInterval = null;
        }
      },
      carregarAcompanhamentoLogs() {
        if (!this.dialogAcompanhamentoLogsId) {
          return;
        }

        this.dialogAcompanhamentoLogsLoading = true;
        RacionalizacaoComService.andamento(this.dialogAcompanhamentoLogsId)
          .then((response) => {
            this.dialogAcompanhamentoLogsMessages = response.data.data || [];
          })
          .catch(() => {
            this.$toast.error('Erro ao carregar logs da execução.', '', { position: 'topRight' });
          })
          .finally(() => {
            this.dialogAcompanhamentoLogsLoading = false;
          });
      },
      openDialogDetalhes(item) {
        this.dialogDetalhesData = [
          { parametro: 'ID', valor: item.id },
          { parametro: 'Nome', valor: item.nome },
          { parametro: 'Status', valor: item.status },
          {
            parametro: 'Processado em',
            valor: item.data_processamento ? this.formatDateHour(item.data_processamento) : '-'
          },
          { parametro: 'Criado por', valor: item.usuario ? item.usuario.nome : '-' },
          { parametro: 'Criado em', valor: this.formatDateHour(item.created) || '-' }
        ];
        this.dialogDetalhes = true;
      }
    }
  };
</script>

<style>
  .swithInterna label {
    font-size: 13px !important;
    margin-left: 0px !important;
  }

  .clickable-item {
    cursor: pointer;
    color: #e5502c;
  }
</style>
